<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<span epub:type="pagebreak" id="page8" title="8">
<div id="acks">
<h1 class="acks-hed">ACKNOWLEDGMENTS</h1>
<p class="nonindent">Thank you to my supportive family, including my amazing husband. You know there is no one else on earth I would rather share a “table for two” with.</p>
<p class="indent">Thank you to everyone at Houghton Mifflin Harcourt for turning my cookbook dreams into reality. A special thank-you to Justin Schwartz. And thank you to my agent, Holly Schmidt, and Hollan Publishing.</p>
<p class="indent">And most importantly, thank you to all my <a href="http://HealthyHappyLife.com" target="_blank">HealthyHappyLife.com</a> readers and <a href="http://FindingVegan.com" target="_blank">FindingVegan.com</a> fans. You are the reason I am able to do what I love for a living, creating recipes and sharing them with the world. The kindness and compassion I have received from my loyal blog readers is beyond priceless to me. Thank you. I cannot wait to continue to share my crazy, amazing, food-infused journey with you guys!</p>
<p class="indent">Thank you to YOU for buying this book. I want to wish you all the success in the world when it comes to your wellness goals. Believe in yourself, be kind to yourself, and you can do anything.</p>
<p class="indent">Love, light, and happy wishes to you all. Xo </p>
<p class="indent">—Kathy</p>
</div>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page008.vue?5185e1f0